define(["exports", "./Comments", "./Languages", "./Navigation", "./NavigationUser", "./SearchProfessionals", "./TabProvider", "./AccordionProvider", "./MiniCV", "./ContentPlaceholder", "./EmptyMessage", "./Footer", "./Modal", "./Toast", "./ToasterContainer"], function (_exports, _Comments, _Languages, _Navigation, _NavigationUser, _SearchProfessionals, _TabProvider, _AccordionProvider, _MiniCV, _ContentPlaceholder, _EmptyMessage, _Footer, _Modal, _Toast, _ToasterContainer) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    Comments: true,
    Languages: true,
    Navigation: true,
    NavigationUser: true,
    SearchProfessionals: true,
    TabProvider: true,
    AccordionProvider: true,
    MiniCV: true
  };
  Object.defineProperty(_exports, "AccordionProvider", {
    enumerable: true,
    get: function get() {
      return _AccordionProvider.default;
    }
  });
  Object.defineProperty(_exports, "Comments", {
    enumerable: true,
    get: function get() {
      return _Comments.default;
    }
  });
  Object.defineProperty(_exports, "Languages", {
    enumerable: true,
    get: function get() {
      return _Languages.default;
    }
  });
  Object.defineProperty(_exports, "MiniCV", {
    enumerable: true,
    get: function get() {
      return _MiniCV.default;
    }
  });
  Object.defineProperty(_exports, "Navigation", {
    enumerable: true,
    get: function get() {
      return _Navigation.default;
    }
  });
  Object.defineProperty(_exports, "NavigationUser", {
    enumerable: true,
    get: function get() {
      return _NavigationUser.default;
    }
  });
  Object.defineProperty(_exports, "SearchProfessionals", {
    enumerable: true,
    get: function get() {
      return _SearchProfessionals.default;
    }
  });
  Object.defineProperty(_exports, "TabProvider", {
    enumerable: true,
    get: function get() {
      return _TabProvider.default;
    }
  });
  _Comments = _interopRequireDefault(_Comments);
  _Languages = _interopRequireDefault(_Languages);
  _Navigation = _interopRequireDefault(_Navigation);
  _NavigationUser = _interopRequireDefault(_NavigationUser);
  _SearchProfessionals = _interopRequireDefault(_SearchProfessionals);
  _TabProvider = _interopRequireDefault(_TabProvider);
  _AccordionProvider = _interopRequireDefault(_AccordionProvider);
  _MiniCV = _interopRequireDefault(_MiniCV);
  Object.keys(_ContentPlaceholder).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _ContentPlaceholder[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ContentPlaceholder[key];
      }
    });
  });
  Object.keys(_EmptyMessage).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _EmptyMessage[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _EmptyMessage[key];
      }
    });
  });
  Object.keys(_Footer).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _Footer[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Footer[key];
      }
    });
  });
  Object.keys(_Modal).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _Modal[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Modal[key];
      }
    });
  });
  Object.keys(_Toast).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _Toast[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Toast[key];
      }
    });
  });
  Object.keys(_ToasterContainer).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _ToasterContainer[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _ToasterContainer[key];
      }
    });
  });
});